import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { CollectionToolbarUniDriver } from '../CollectionToolbar/CollectionToolbar.uni.driver';
import { CollectionListItemUniDriver } from '../CollectionListItem/CollectionListItem.uni.driver';
import { baseUniDriverFactory } from '../../unidriver';
import { SummaryBarUniDriver } from '../SummaryBar/SummaryBar.uni.driver';

export function CollectionListUniDriver(base: UniDriver, body: UniDriver) {
  const toolbar = CollectionToolbarUniDriver(
    base.$('[data-hook="collection-toolbar"]'),
    body,
  );

  const getRow = (index: number) =>
    CollectionListItemUniDriver(
      base.$(`[data-hook="collection-list-row"]:nth-child(${index + 1})`),
      body,
    );

  const getRowsCount = () =>
    base.$$(`[data-hook="collection-list-row"]`).count();
  const getSummaryBar = () => SummaryBarUniDriver(base, body);

  return {
    ...baseUniDriverFactory(base),
    wait: base.wait,
    getRowsCount,
    getRow,
    toolbar,
    /**
     * Gets collection summary bar
     */
    getSummaryBar,
  };
}
